export { FontSizes } from '@fluentui/theme/lib/fonts/FluentFonts';
